export const MEMBERSHIP_HEADING = {
	TITLE: "MEMBERSHIP",
};

export const MEMBERSHIP = {
	INFO: "Check the box next to the role name to add ",
	INFO_1: "Uncheck the box next to the role name to remove ",
	INFO_2: "Click Save Changes to save the new role membership you selected.",
};

export const WCN = {
	WCN_MAP: "WCN Mapping",
	WCN_SELECT: "select all WCNs that apply to add ",
};

export const USER_INFO = {
	NAME: "User Name",
	ID: "ID",
	EMAIL: "Email",
};
export const USER_DESCRIPTION = {
	USER_DETAILS: "User Details",
	NOTE: "Note - You can only change the organization for a  user",
};

export const ROLE = {
	ROLE_TITLE: "Digital Platform Roles",
	ROLE_TITLE_2: "New Role Onboarding Instructions",
};
export const ROLE_DESCRIPTION = {
	DESCRIPTION_1:
		"Add a new role for the organization's administrators in the form of",
	DESCRIPTION_2: "There can be no spaces in the Organization's name.",
	DESCRIPTION_3:
		"There must be an underscore between the Organization's Name and the word ADMINS.",
	DESCRIPTION_4: "Add a new role for the organization's users in the form of",
	DESCRIPTION_5: "There can be no spaces in the Organization's name.",
	DESCRIPTION_6:
		"There must be an underscore between the Organization's Name and the word USERS.",
	DESCRIPTION_7:
		"All Role names are saved in UPPER CASE. They will be converted to upper case automatically.",
	DESCRIPTION_8:
		"Add one organization user account to both ORGANIZATION_ADMINS and ORGANIZATION_USERS.",
	DESCRIPTION_9:
		"The main user account for the new organization role can now manage all users for thier organization only.",
};

export const DESCRIPTION_FOR_ROLES = {
	ER_SUPERADMIN:
		"Can perform all the actions like other roles (Enroll/ Edit Vessel, Import Report, etc..) except port codes, can delete a report irrespective of its status.",
	ER_PORTCODEADMIN: "Similar to Super Admin and can Add/Edit the Port codes.",
	ER_ADMIN: "Admin",
	ER_VERIFIER:
		"Assign child report to Reviewer, can enable client users to download the deliverables (Review Letter, Statement of Compliance).",
	ER_REVIEWER:
		"Claims the child report, create / Resolve / Delete the Correction Requests. Assign the report to the Verifier for Verification.",
	ER_CLIENT:
		"Enroll Vessels for assigned WCNs, Import Report, Upload supporting documents, can reply to Correction Requests, download deliverables, can delete their report if it is not yet submitted to ABS.",
	ER_USER: "User",
	ER_ABSTESTER: "ABS Tester",
};
